import { Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { useProductsTFunction } from '@retail/products/i18n';
import { Chip } from '@shared/components';
import { MgPackagesButtonGroup } from './MgPackagesButtonGroup';
import { useState } from 'react';
import { ArmScaleIcon } from '@shared/custom-icons';
import { capitalizeFirstLetter } from '@shared/utils';
import { MgItemPackages, MgPackageType } from '@retail/products/types';
import { CopyToClipboard } from '@retail/components';

interface Props {
  uniquePackages: MgItemPackages;
  isSuperUser: boolean;
}

export const MgItemDetailsPackaging = ({ uniquePackages, isSuperUser }: Props) => {
  const t = useProductsTFunction();

  const theme = useTheme();
  const { tint } = theme.vars.palette.semantic;

  const [selectedItem, setSelectedItem] = useState<MgPackageType>('PRIMARY');
  const selectedMgPackages = uniquePackages[selectedItem];

  return (
    <Box
      display="flex"
      flexGrow={1}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      border="1px solid"
      borderColor="grey.100"
      borderRadius={1}
      px={2}
    >
      <Typography fontWeight={600} my={1}>
        {t('products.mgItem.supplierItem.packages')}
      </Typography>

      <MgPackagesButtonGroup
        packages={uniquePackages}
        isSuperUser={isSuperUser}
        selectedPackage={selectedItem}
        setSelectedPackage={setSelectedItem}
      />

      <Box my={2}>
        {selectedMgPackages?.map((selectedMgPackage, index) => {
          return (
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              gap={1}
              key={selectedMgPackage.gtinCode ?? selectedMgPackage.unit.description}
              mb={index < selectedMgPackages.length - 1 ? 1 : 0}
            >
              <Box display="flex" alignItems="center" mr={2}>
                {t('products.mgItem.supplierItem.unit')}:{' '}
                <Typography
                  display="flex"
                  alignItems="center"
                  fontWeight={600}
                  component={Box}
                  ml={1}
                >
                  <Chip
                    rounded
                    backgroundColor={tint.sky.medium}
                    textColor={tint.sky.text}
                    label={
                      <Typography fontWeight={500}>
                        {capitalizeFirstLetter(selectedMgPackage?.unit.description)}
                      </Typography>
                    }
                  />

                  {!selectedMgPackage.gtinCode && (
                    <ArmScaleIcon sx={{ ml: 0.5 }} fontSize="small" />
                  )}
                </Typography>
              </Box>

              {selectedMgPackage.gtinCode && (
                <Box display="flex" alignItems="center">
                  {t('products.mgItem.supplierItem.gtin')}:{' '}
                  <Typography component={Box} ml={1}>
                    <CopyToClipboard value={selectedMgPackage.gtinCode}>
                      {selectedMgPackage.gtinCode}
                    </CopyToClipboard>
                  </Typography>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
